import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en.json';
import frTranslation from './locales/fr.json';
import ptTranslation from './locales/pt.json';

const savedLanguage = localStorage.getItem('language') || 'fr';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslation,
    },
    fr: {
      translation: frTranslation,
    },
    pt: {
      translation: ptTranslation,
    },
  },
  lng: savedLanguage,
  fallbackLng: 'fr',
  returnObjects: true,
  interpolation: {
    escapeValue: false,
  },
});
